import axios from 'axios'
import store from '@/store'
import { theme } from '@/utils/theme'
import qs from 'qs'

export function pay (params) {
  return axios({
    url: `//pay.${theme[store.getters.init.ui_type].gameName}.com/api/h5/index.php`,
    method: 'get',
    params: {
      imei: store.getters.idfa,
      ...params
    }
  })
}

export function wftWxJsPay (params) {
  return axios({
    url: `//pay.${theme[store.getters.init.ui_type].gameName}.com/api/h5/wft_wx_js.php`,
    method: 'get',
    params: {
      imei: store.getters.idfa,
      ...params
    }
  })
}

export function checkOrder (params) {
  return axios({
    url: `//pay.${theme[store.getters.init.ui_type].gameName}.com/api/h5/query_order.php`,
    method: 'get',
    params: {
      imei: store.getters.idfa,
      ...params
    }
  })
}

export function qutongWXPay (params) {
  return axios({
    url: `http://api.${theme[store.getters.init.ui_type].gameName}.com/sdk/order/wx_wap_pay_h5`,
    method: 'post',
    data: params
  })
}

export function qutongAliPay (params) {
  return axios({
    url: `http://api.${theme[store.getters.init.ui_type].gameName}.com/sdk/order/ali_wap_pay_h5`,
    method: 'post',
    data: params
  })
}

export function paySwitch (params) {
  return axios({
    url: `//pay.${theme[store.getters.init.ui_type].gameName}.com/api/h5/switch.php`,
    method: 'get',
    params
  })
}

export function payApple (params) {
  return axios({
    url: `//pay.${theme[store.getters.init.ui_type].gameName}.com/api/h5/apple.php`,
    method: 'post',
    data: qs.stringify({
      imei: store.getters.idfa,
      ...params
    })
  })
}
